import LText from "@components/LText";
import { Platform } from "react-native";

const PageTitle = ({ title }: { title?: string }) => (
  <LText
    fontSize={20}
    lineHeight={20}
    fontWeight={600}
    numberOfLines={1}
    style={
      Platform.OS === "web"
        ? ({ overflowX: "clip", overflowY: "visible" } as any)
        : undefined
    }
  >
    {title}
  </LText>
);

export default PageTitle;
